// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"TextFooter_headerContainer__a_9Ko","icon":"TextFooter_icon__J5_Ug","textContainer":"TextFooter_textContainer__p1V2O"};